<template>
  <a-modal v-model="modal" title="执行运算" width="500px" :maskClosable="false" :closable="false">
    <div>PS:注意该时间为非必填项，选择时间确认后将只针对所选时间的工单进行分仓，不选时间则只分仓次日的工单</div>
    <a-form-model
      :model="formData"
      ref="form"
    >
      <a-form-model-item
        label="工单计划完成时间"
        :labelCol="{ style: 'width: 130px;float:left' }"
        :wrapperCol="{ style:'width:calc(100% - 130px );float:left'}"
      >
        <a-date-picker style="width:100%" v-model="formData.scheduledCompletionDate" @change="changeDate" :disabled-date="disabledEndDate" />
      </a-form-model-item>
    </a-form-model>
    <template #footer>
      <a-space>
        <a-button :loading="loading" @click="modal=false;$refs.form.resetFields();">取消</a-button>
        <a-button type="primary" @click="submit" :loading="loading">确定</a-button>
      </a-space>
    </template>
  </a-modal>
</template>

<script>
import {
  apiInvWipAllocationPlanCompartmentOperations
} from '@/api/mes/scheduling-plan/sub-warehouse-plan'

export default {
  name: 'ExecuteOperationModal',
  data() {
    return {
      modal: false,
      formData: {
        scheduledCompletionDate: ""
      },
      loading: false,
      rules: {
        scheduledCompletionDate: [
          { required: true, message: '', trigger: 'change' }
        ]
      }
    }
  },
  methods: {
    show () {
      this.modal = true
      this.$nextTick(() => {
        this.formData.scheduledCompletionDate = ""
        this.$refs.form.resetFields()
      })
    },
    submit () {
      this.loading = true;
      const params = {
        scheduledCompletionDate: this.formData.scheduledCompletionDate
      }
      apiInvWipAllocationPlanCompartmentOperations(params).then(response => {
        if (response.code === 200) {
          this.modal = false
          this.$message.success('执行运算成功!')
          this.$emit("click")
        } else {
          this.$message.error(response.msg)
        }
      }).finally(() => {
        this.loading = false
      })
    },
    // 修改到货日期
    changeDate (val) {
      this.formData.scheduledCompletionDate = this.momentFun(val)
    },
    disabledEndDate (date) {
      return date && date.valueOf() < Date.now() - 86400000;
    }
  }
}
</script>

<style scoped>

</style>
